var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Interactions (Historical)")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying Past Interactions")])])]), _c('br'), (_vm.loading) ? _c('div', [_vm._v(_vm._s(_vm.loadingText))]) : _c('div', [(_vm.tableItemsFlag.length > 0) ? _c('div', [_c('app-interactionsTable', {
    attrs: {
      "data": _vm.tableItemsFlag,
      "label": _vm.tableFieldsFlag,
      "rowClick": "rowClick"
    }
  }), _c('br')], 1) : _vm._e(), (!_vm.boss) ? _c('app-interactionsTable', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "rowClick": "rowClick"
    }
  }) : _vm._e(), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('b-pagination-nav', {
    staticClass: "pagination-area",
    attrs: {
      "base-url": "/#/interactions/historical?page=",
      "align": "right",
      "size": "md",
      "total-rows": _vm.pages,
      "number-of-pages": _vm.totalPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form', {
    on: {
      "submit": _vm.paginateTo
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Page number",
      "state": _vm.inputPageNumberState
    },
    model: {
      value: (_vm.inputPageNumber),
      callback: function($$v) {
        _vm.inputPageNumber = $$v
      },
      expression: "inputPageNumber"
    }
  }), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Paginate"),
      expression: "\"Paginate\"",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-columns"
  })])], 1)], 1)], 1), (_vm.inputPageNumberState == false) ? _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Wrong input")]) : _vm._e()], 1)])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f879268","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Interactions.vue
// module id = 892
// module chunks = 1